import { apiService } from './api';
import { logger } from '../utils/logger';

export interface Position {
  id: string;
  oracleId?: string;
  name: string;
  description?: string;
  mappedRoles: string[];
  dateCreated?: string;
  isDeleted: boolean;
}

export interface CreatePositionData {
  oracleId?: string;
  name: string;
  description?: string;
  mappedRoles?: string[];
}

export interface UpdatePositionData {
  name?: string;
  description?: string;
  mappedRoles?: string[];
}

export const positionService = {
  async getPositions(): Promise<Position[]> {
    logger.log('📡 positionService.getPositions() - Calling API...');
    try {
      const response = await apiService.get<{ success: boolean; positions: Position[] }>('/api/positions');
      if (!response?.success || !Array.isArray(response.positions)) {
        throw new Error('Invalid response from API');
      }
      logger.log('✅ positionService.getPositions() - Returning', response.positions.length, 'positions');
      return response.positions;
    } catch (error) {
      logger.error('❌ positionService.getPositions() - Error:', error);
      throw error;
    }
  },

  async createPosition(positionData: CreatePositionData): Promise<Position> {
    logger.log('📡 positionService.createPosition() - Calling API with:', positionData);
    const response = await apiService.post<{ success: boolean; position: Position }>('/api/positions', positionData);
    if (!response?.success || !response.position) {
      throw new Error('Invalid response from API');
    }
    logger.log('✅ positionService.createPosition() - Created position:', response.position);
    return response.position;
  },

  async updatePosition(positionId: string, positionData: UpdatePositionData): Promise<Position> {
    const response = await apiService.put<{ success: boolean; position: Position }>(`/api/positions/${positionId}`, positionData);
    if (!response?.success || !response.position) {
      throw new Error('Invalid response from API');
    }
    return response.position;
  },

  async deletePosition(positionId: string): Promise<void> {
    await apiService.delete<{ success: boolean; message?: string }>(`/api/positions/${positionId}`);
  }
};

